import { render, staticRenderFns } from "./o-home-intro.vue?vue&type=template&id=6c596796&scoped=true&"
import script from "./o-home-intro.vue?vue&type=script&lang=js&"
export * from "./o-home-intro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c596796",
  null
  
)

export default component.exports